import type { SchoolEnrollmentId } from '../types/school-enrollments-interface'

export const schoolKeys = {
  all: ['school'] as const,
  bundle: (schoolEnrollmentId: SchoolEnrollmentId | null) =>
    [...schoolKeys.all, 'bundle', { schoolEnrollmentId }] as const,
}
